var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-xml","size":"lg","title":"QTI 3 XML","title-class":"font-18","scrollable":"","hide-footer":""}},[_vm._v(" "+_vm._s(_vm.itemXml)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }